/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type CurrentContractListItemProposedStepActionType =
  (typeof CurrentContractListItemProposedStepActionType)[keyof typeof CurrentContractListItemProposedStepActionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurrentContractListItemProposedStepActionType = {
  Keep: "Keep",
  Cancel: "Cancel",
  Contracting: "Contracting",
  Modify: "Modify",
} as const;
